module.exports = __webpack_public_path__ + "static/pocket-pills-en-361a3b04f1a713464b407702800cbff1.png";